import { SoftwareSoldItemFilter } from './softwareSoldTypes';

export const filterConstraintChecker = (
  name: string,
  value: string,
  filters: SoftwareSoldItemFilter
) => {
  if (name === 'soldDateFrom') {
    if (filters.soldDateTo && filters.soldDateTo < value) return false;
  }
  if (name === 'soldDateTo') {
    if (filters.soldDateFrom && filters.soldDateFrom > value) return false;
  }
  return true;
};

export const itemValidator = (item: any) => {
  if (!item.license) return false;
  if (!item.software) return false;
  if (!item.hardware) return false;
  if (!item.company) return false;
  if (item.modulesToAdd) {
    for (const module of item.modulesToAdd) {
      if (!module.module || !module.license) return false;
    }
  }
  return true;
};

export const addModuleMiddleware = (
  name: string,
  value: string,
  state: any,
  autoboxValue?: object,
  autoboxLabel?: string
) => {
  if (autoboxLabel === 'order') return { order: autoboxValue };
  if (autoboxLabel === 'module') return { module: autoboxValue };
  return {};
};
